import { addReservationToCloud, deleteReservationFromCloud, incrementMassReservations } from "../../firebase/firebase.utils";
import random from 'random-key-generator';
//import { sendReservationEmail } from "../../email/email.util";



export const incrementQty = (candidate, mass) => { 

    /*The maximum number of seats that can be reserved is a bit complex.  It is the smaller of these numbers:
      1) the remaining seat capacity, 2) the seating capacity of a pew, 3) the seating capacity of a section if only one section left
    */
    const ifOne = (mass.availSections <= 1 ) ? mass.seatsPerSection : mass.seatsPerPew;
    return (candidate.qty === Math.min(mass.seatsPerPew, mass.availSeats, ifOne) ? candidate : {...candidate, qty: candidate.qty + 1 });
};

export const decrementQty = (candidate) => { 
    return (candidate.qty === 1 ? candidate : {...candidate, qty: candidate.qty - 1 });
};


export const addItemToReservations =  (item) => {
    
    const { reservationItem } = item;
    const { massId, qty } = reservationItem;
    const { massInfo } = item;
    const { seatsPerSection } = massInfo;
    let sections = 1;

    /*First determine the number of sections that are needed */
    if (qty > seatsPerSection) {
        sections = 2;
    };
    const newReservationItem = { sections: sections, ...reservationItem};
    
  
    incrementMassReservations(massId, qty, sections, true);

    /* Save the reservation in the Reservation database and add the document name to the 
     local reservation object */
   
    const reservationId = random(10);
    //const tempReservation = {...reservationItemToAdd, cloudId : reservationId};
    addReservationToCloud(reservationId, newReservationItem);
    //sendReservationEmail(item);

    /* Add the new object to local state */
    return [];

};

export const removeItemFromReservations = (reservationItems, reservationItemToRemove) => {

    const {cloudId, massId, qty, sections } = reservationItemToRemove;

    deleteReservationFromCloud(cloudId);
    incrementMassReservations(massId, qty, sections, false);

    return reservationItems.filter(reservationItem => reservationItem.id !== reservationItemToRemove.id);  
};
